export default "__VITE_ASSET__5e2ce0f8__"